import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { text } from '@guardian/src-foundations/palette';
import { Zero } from '@root/src/web/components/numbers/Zero';
import { One } from '@root/src/web/components/numbers/One';
import { Two } from '@root/src/web/components/numbers/Two';
import { Three } from '@root/src/web/components/numbers/Three';
import { Four } from '@root/src/web/components/numbers/Four';
import { Five } from '@root/src/web/components/numbers/Five';
import { Six } from '@root/src/web/components/numbers/Six';
import { Seven } from '@root/src/web/components/numbers/Seven';
import { Eight } from '@root/src/web/components/numbers/Eight';
import { Nine } from '@root/src/web/components/numbers/Nine';
import { Ten } from '@root/src/web/components/numbers/Ten';
export const Score = ({ score }) => {
    const ScoreStyles = ({ children }) => (_jsx("div", Object.assign({ css: css `
				position: relative;
				width: 3.75rem;
				height: 3.75rem;
				border-radius: 1.875rem;
				border: 0.0625rem solid ${text.primary};

				svg {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					margin: auto;
				}
			` }, { children: children }), void 0));
    switch (score) {
        case 0:
            return (_jsx(ScoreStyles, { children: _jsx(Zero, {}, void 0) }, void 0));
        case 1:
            return (_jsx(ScoreStyles, { children: _jsx(One, {}, void 0) }, void 0));
        case 2:
            return (_jsx(ScoreStyles, { children: _jsx(Two, {}, void 0) }, void 0));
        case 3:
            return (_jsx(ScoreStyles, { children: _jsx(Three, {}, void 0) }, void 0));
        case 4:
            return (_jsx(ScoreStyles, { children: _jsx(Four, {}, void 0) }, void 0));
        case 5:
            return (_jsx(ScoreStyles, { children: _jsx(Five, {}, void 0) }, void 0));
        case 6:
            return (_jsx(ScoreStyles, { children: _jsx(Six, {}, void 0) }, void 0));
        case 7:
            return (_jsx(ScoreStyles, { children: _jsx(Seven, {}, void 0) }, void 0));
        case 8:
            return (_jsx(ScoreStyles, { children: _jsx(Eight, {}, void 0) }, void 0));
        case 9:
            return (_jsx(ScoreStyles, { children: _jsx(Nine, {}, void 0) }, void 0));
        case 10:
        default:
            return (_jsx(ScoreStyles, { children: _jsx(Ten, {}, void 0) }, void 0));
    }
};
